import styled from 'styled-components';
import breakpoints from '../breakpoints';

const H1 = styled.h1`
  color: #ffffff;
  display: block;
  font-family: 'Ivar Headline', 'Times New Roman', serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 38px;
  margin: 0 auto;
  max-width: 320px;

  @media ${breakpoints.medium} {
    font-size: 46px;
    line-height: 58px;
    max-width: 900px;
  }
`;

const H2 = styled.h2`
  color: ${(props) => props.color || '#2A2A33'};
  font-family: 'Open Sans', sans-serif;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 32px;
  margin: 0 auto;
  text-align: center;

  @media ${breakpoints.medium} {
    font-size: 32px;
    line-height: 42px;
  }
`;

const H3 = styled.h3`
  color: #30303b;
  font-family: 'Open Sans', sans-serif;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 32px;
  text-align: center;

  @media ${breakpoints.large} {
    text-align: left;
  }
`;

const H4 = styled.h4`
  color: ${(props) => props.color || '#3E3E4E'};
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24.7px;
  padding: ${(props) => props.padding || '0'};
  text-align: center;

  @media ${breakpoints.large} {
    text-align: ${(props) => props.forceAlign || 'left'};
  }
`;

export default {
  H1,
  H2,
  H3,
  H4,
};
